import { render, staticRenderFns } from "./informationMenu.vue?vue&type=template&id=203cb7d7&scoped=true&"
import script from "./informationMenu.vue?vue&type=script&lang=js&"
export * from "./informationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203cb7d7",
  null
  
)

export default component.exports